<template>
  <div class="list-wrapper">
    <div class="header" v-if='!isapplets'>
      <van-icon name="arrow-left" size="20" color="#333" @click="goBack"/>
    </div>
    <div class="pdf_wrapper">
      <iframe :src="url" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
  import record from '../../utils/record.js'
  import timeFormats from '../../utils/timeFormat_record.js'

  export default {
    data () {
      return {
        url: '//l.eoffcn.com/courseoutline/pdfview/web/viewer.html?file=' + this.$route.query.url,
        numPages: null, // pdf 总页数
        toast: '',
        isapplets: false
      }
    },
    mounted () {
      // 小程序内
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.isapplets = true
        }
      })
      this.uprecord()
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      uprecord () {
        let inTime = new Date().getTime()
        let recordParams = {
          erp_id: this.$route.query.order_id,
          cid: this.$route.query.cid,
          package_id: this.$route.query.package_id,
          course_id: 0,
          unit_id: this.$route.query.unit_id,
          action_time: timeFormats(new Date() / 1000),
          product: 2,
          is_online: 1,
          module_type: this.$route.query.module_type,
          course_type: 1,
          version: 0,
          other: this.$route.query.other
        }
        record(recordParams)
      }
    }
  }
</script>

<style lang="less">
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 90px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px 0 25px;
    color: #333;
    z-index: 1;
  }

  .pdf_wrapper {
    height: 100vh;
    margin-top: 90px;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/file/index.vue